import React, { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { HelpCircle } from 'lucide-react';
import { HelpAssistantChat } from './HelpAssistantChat';
import { useHelpAssistant } from '../hooks/useHelpAssistant';

export function HelpAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const { messages, isLoading, sendMessage } = useHelpAssistant();

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="fixed bottom-4 right-4 h-12 w-12 rounded-full shadow-lg hover:bg-primary/10"
        >
          <HelpCircle className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent className="w-[90vw] sm:w-[440px]">
        <SheetHeader>
          <SheetTitle>Hjelp og Support</SheetTitle>
        </SheetHeader>
        <HelpAssistantChat
          messages={messages}
          isLoading={isLoading}
          onSendMessage={sendMessage}
        />
      </SheetContent>
    </Sheet>
  );
}